<template>
  <div class="py-4 login-view-container mx-auto">
    <div class="login-view">
      <h1 class="login-view-title mb-4">{{ multiLanguage.LoginTitle }}</h1>
      <div class="login-container">
        <login
          :backlink="sanitizedBacklink"
          :has-to-forward="true"
          :multi-language="multiLanguage"
        >
          <template #extend-overlay-buttons>
            <slot name="extend-overlay-buttons"></slot>
          </template>
        </login>
      </div>

      <div class="register-container">
        <h3>{{ multiLanguage.LoginSubTitle }}</h3>
        <p>
          {{ multiLanguage.LoginText }}
        </p>
        <div class="register-buttons">
          <div>
            <a :href="registrationUrl">
              <button class="btn btn-primary btn-block mb-3">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
                <span>{{ multiLanguage.LoginButton1 }}</span>
              </button>
            </a>
          </div>

          <div v-if="!myAccountInBacklink">
            <button
              class="btn btn-primary btn-block mb-3"
              @click="openGuestModal()"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.00014 14H18.1359C19.1487 14 19.6551 14 20.0582 13.8112C20.4134 13.6448 20.7118 13.3777 20.9163 13.0432C21.1485 12.6633 21.2044 12.16 21.3163 11.1534L21.9013 5.88835C21.9355 5.58088 21.9525 5.42715 21.9031 5.30816C21.8597 5.20366 21.7821 5.11697 21.683 5.06228C21.5702 5 21.4155 5 21.1062 5H4.50014M2 2H3.24844C3.51306 2 3.64537 2 3.74889 2.05032C3.84002 2.09463 3.91554 2.16557 3.96544 2.25376C4.02212 2.35394 4.03037 2.48599 4.04688 2.7501L4.95312 17.2499C4.96963 17.514 4.97788 17.6461 5.03456 17.7462C5.08446 17.8344 5.15998 17.9054 5.25111 17.9497C5.35463 18 5.48694 18 5.75156 18H19M7.5 21.5H7.51M16.5 21.5H16.51M8 21.5C8 21.7761 7.77614 22 7.5 22C7.22386 22 7 21.7761 7 21.5C7 21.2239 7.22386 21 7.5 21C7.77614 21 8 21.2239 8 21.5ZM17 21.5C17 21.7761 16.7761 22 16.5 22C16.2239 22 16 21.7761 16 21.5C16 21.2239 16.2239 21 16.5 21C16.7761 21 17 21.2239 17 21.5Z"
                  stroke="#fff"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
              <span>{{ multiLanguage.LoginButton2 }}</span>
            </button>
          </div>
        </div>
      </div>

      <slot name="additional-content-after-buttons"></slot>
    </div>

    <div class="modal fade" ref="guestModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered px-3">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title h3">
              {{ $translate("Ceres::Template.loginOrderAsGuest") }}
            </div>
            <button
              type="button"
              class="close"
              data-testing="guest-login-modal"
              data-dismiss="modal"
              aria-hidden="true"
              :aria-label="$translate('Ceres::Template.closeIcon')"
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="40"
                  height="40"
                  rx="20"
                  fill="white"
                  fill-opacity="0.68"
                />
                <path
                  d="M28.3332 11.667L11.6665 28.3337M11.6665 11.667L28.3332 28.3337"
                  stroke="#090909"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <guest-login
              :backlink="sanitizedBacklink"
              :initial-email="guestEmail"
              :multi-language="multiLanguage"
            ></guest-login>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalService from "../../../services/ModalService";

export default {
  props: {
    backlink: {
      type: String,
      default: "",
    },
    guestEmail: {
      type: String,
    },
    multiLanguage: Object,
  },
  components: {
    login: () => import("./Login.vue"),
    "guest-login": () => import("./GuestLogin.vue"),
  },

  computed: {
    registrationUrl() {
      if (this.backlink !== "") {
        return App.urls.registration + "?backlink=" + this.sanitizedBacklink;
      }

      return App.urls.registration;
    },

    sanitizedBacklink() {
      return encodeURI(this.backlink);
    },

    myAccountInBacklink() {
      return this.backlink.includes(App.urls.myAccount);
    },
  },

  methods: {
    openGuestModal() {
      ModalService.findModal(this.$refs.guestModal).show();
    },
  },

  mounted() {
    const loadingSkeleton = document.getElementById("loadingSkeleton");

    const loadedContent = document.getElementById("loadedContent");

    if (loadingSkeleton) {
      loadingSkeleton.classList.add("d-none");
    }

    if (loadedContent) {
      loadedContent.classList.remove("d-none");
    }
  },
};
</script>
